import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'mm-input-page',
  templateUrl: './input-page.component.html',
  styleUrls: ['./input-page.component.scss']
})
export class InputPageComponent {
  @Input() palAccountInContext: boolean;
  @Output() showTemplateModal = new EventEmitter<boolean>();
  @Output() showTweModal = new EventEmitter<boolean>();
  @Output() showOverdraftRulesPopup = new EventEmitter<string>();

  destroy$ = new Subject<void>();
  private formStartedStatus$ = new BehaviorSubject(false);
  formStartedStatusObs$: Observable<boolean> = this.formStartedStatus$.asObservable()
  
  constructor() { }

  formHasBeenStartedEvent($event: boolean): void {
    this.formStartedStatus$.next($event);
  }

  showTweModalEvent($event: boolean): void {
    this.showTweModal.emit($event);
  }

  showTemplateModalEvent($event: boolean): void {
    this.showTemplateModal.emit($event);
  }

  showOverdraftRulesPopupEvent($event: string): void {
    this.showOverdraftRulesPopup.emit($event);
  }
}
